import AnchorLink from 'components/shared/AnchorLink/AnchorLink'
import PropTypes from 'prop-types'

import './AnchorLinksList.scss'

export const AnchorLinksList = ({ anchorLinkInfo = [] }) => {
  return (
    <div className="anchor-links__container">
      <div className="anchor-links">
        {anchorLinkInfo.map((info) => (
          <AnchorLink {...info} key={info.id} />
        ))}
      </div>
    </div>
  )
}

AnchorLinksList.propTypes = {
  anchorLinkInfo: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      image: PropTypes.shape({
        alt: PropTypes.string.isRequired,
        src: PropTypes.string.isRequired,
      }).isRequired,
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ),
}

export default AnchorLinksList
